module.exports = "/_next/static/images/9e0973c9fe427763e55f07bb84ec5e45-roxinho-scene-card-with-phone-xs@2x.jpg";